/*
* Client search view for authenticated users
*/

import { Grid } from '@progress/kendo-grid-react-wrapper';
import '@progress/kendo-ui';
import * as _ from 'lodash';
import * as React from 'react';
import { Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { connectRequest } from 'redux-query';

import * as Actions from '../actions';
import * as AppComp from '../common/app-component-base';
import { BootstrapColXl as Col } from '../common/bootstrap/bootstrapcolxl';
import { Formatters } from '../common/formatters';
import { GridUtilities } from '../common/grid/gridutilities';
import { NavigationLinks } from '../common/navigation';
import SearchInput from '../common/searchInput';
import { WhiteBoxPageSection } from '../common/whiteboxpagesection';
import ApiEndpoints from '../config/apiendpoints';
import * as ReduxQueries from '../queries';

class ClientSearch extends AppComp.AppComponent {
    public colTemplate = GridUtilities.kendoGridLinkColumnTemplate('clientName', 'clientDetailLinkHref', this.appText('client-detail-link-title'));
    public gridOptions = GridUtilities.kendoGridOptionsPaging(
        [
            GridUtilities.kendoGridColumnDefinition('clientId', this.appTextGridColumnHeader('client-id'), 60, 1),
            GridUtilities.kendoGridColumnDefinition('clientName', this.appTextGridColumnHeader('client-name'), 250, 2, this.colTemplate),
            GridUtilities.kendoGridColumnDefinition('clientLocation', this.appTextGridColumnHeader('location'), 200, 3),
        ],
        this.appText('no-results'),
        {},
        this.appTextPageTitle()
    );
    public debouncedSearch: (keyword: string) => void;

    public constructor(props: any) {
        super(props, 'app.client-search.');

        this.debouncedSearch = _.debounce(
            (keyword: string) => {
                this.props.dispatch(Actions.searchClientsKeyword(keyword));
            },
            500
        );
    }

    public extendGridData(records: Array<any>): Array<any> {
        // Assign default filter
        if (!records) { return []; }

        return records.map(r => {
            let record = Object.assign({}, r);

            // Client Location
            record.clientLocation = Formatters.composeLocationCityState(record.location);

            // Client name
            record.clientName = '';
            if (record.name) {
                record.clientName = record.name;
            }

            // Client detail link
            record.clientDetailLinkHref = '';
            if (record.clientId) {
                record.clientDetailLinkHref = NavigationLinks.clientDetail(record.clientId);
            }

            return record;
        });
    }

    public handleSearchFilter = (e: any): void => {
        const keyword = e.target.value;
        this.props.dispatch(Actions.searchClientsKeyword(keyword));
    }

    public handleFormSubmit = (e: any): void => {
        e.preventDefault();
    }

    public render(): JSX.Element {
        const rows = this.extendGridData(this.props.search.results);
        const dataSource = GridUtilities.kendoGridDataSourcePaged(rows);

        const { ...rest } = this.props;

        const pageTitle = this.appTextResultsAndPageTitle(rows.length);

        const page = (
            <WhiteBoxPageSection title={pageTitle}>
                <Row>
                    <Col xs={12}>
                        <form className="form-horizontal" onSubmit={this.handleFormSubmit}>
                            <div className="form-group">
                                <label className="col-xs-1 col-md-2 col-xl-1 control-label">{this.appText('search-keyword')}</label>
                                <div className="col-xs-2 col-md-4 col-xl-2">
                                    <SearchInput
                                        onChange={this.handleSearchFilter}
                                        placeholder={this.appText('enter-keyword')}
                                        value={this.props.search.term}
                                    />
                                </div>
                            </div>
                        </form>
                    </Col>
                </Row>

                <Row>
                    <Col xs={12}>
                        <Grid dataSource={dataSource} {...this.gridOptions} />
                    </Col>
                </Row>
            </WhiteBoxPageSection>
        );

        return (
            <AppComp.RenderPageWithLayout
                branding={this.props.branding}
                pageName={pageTitle}
                {...rest}
            >
                {page}
            </AppComp.RenderPageWithLayout>
        );
    }
}

const getApiUrl = () => ApiEndpoints.getSearchClientsUrl();

const mapPropsToConfigs = (props) => {
    return ReduxQueries.Queries.searchClientsRequest(
        getApiUrl(),
        ReduxQueries.PropsAccessToken(props),
        _.get(props, 'search.term', ''),
        _.get(props, 'search.operator', '')
    );
};

const mapStateToProps = (state, props) => {
    const mapped = ReduxQueries.MapQueryStateToPropsByUrl(getApiUrl(), state, props, {
        search: {
            operator: 'OR',
            results: state.entities.searchClientsResults,
            term: state.searchFiltersClients.keyword,
        }
    });

    return mapped;
};

const ClientSearchContainer = compose<any>(
    connect(mapStateToProps),
    connectRequest(mapPropsToConfigs)
)(ClientSearch);

export default withRouter(ClientSearchContainer);



// WEBPACK FOOTER //
// ./src/client-search/index.tsx